<!--
    EiToolingObjectLookupTabComponent Template

    Per recordStructure: accordion panel with
      - resolved object card (if assigned)
      - scoped lookup candidates (reused component)
      - structure-level re-lookup button
-->

@if (!recordStructures || recordStructures.length === 0) {
    <div class="text-center p-4 text-600">
        <i class="fa-regular fa-cube text-3xl mb-2 block text-400"></i>
        <div class="text-sm">Keine Strukturen vorhanden.</div>
    </div>
} @else {
    <p-accordion [multiple]="true" [value]="activePanelValues">
        @for (structure of recordStructures; track structure.id) {
            <p-accordion-panel [value]="structure.id">
                <p-accordion-header>
                    <div class="flex align-items-center gap-2 w-full">
                        <i class="fa-regular fa-cube text-500"></i>
                        <span class="font-bold">
                            {{ structure.objectTypeDtoName ?? 'Unbekannter Objekttyp' }}
                        </span>
                        <span class="text-xs text-500">#{{ structure.id }}</span>
                        <p-tag
                                [value]="assignmentStatusLabel(structure.assignmentStatus)"
                                [severity]="statusSeverity(structure.assignmentStatus)">
                        </p-tag>
                        @if (structure.requiresManualReview) {
                            <p-tag severity="warn" value="Review" icon="fa-solid fa-user-check"></p-tag>
                        }
                        <span class="flex-1"></span>
                        @if (structure.autoFoundSimilarity != null) {
                            <span class="text-sm text-500">
                                {{ similarityPercent(structure.autoFoundSimilarity) }}%
                            </span>
                        }
                    </div>
                </p-accordion-header>
                <p-accordion-content>

                    @if (structure.objectId != null) {
                        <!-- Resolved object card -->
                        <div class="surface-100 border-round p-3 mb-3">
                            <div class="flex align-items-start justify-content-between gap-3">
                                <div class="flex-1 min-w-0">
                                    <div class="text-xs text-600 mb-1">Zugewiesenes Objekt</div>
                                    <div class="font-bold">
                                        {{ structure.objectTypeDtoName ?? 'Objekt' }} #{{ structure.objectId }}
                                    </div>

                                    @if (structure.autoFoundSimilarity != null) {
                                        <div class="mt-2">
                                            <div class="text-xs text-600 mb-1">
                                                Confidence: {{ similarityPercent(structure.autoFoundSimilarity) }}%
                                            </div>
                                            <p-progressBar
                                                    [value]="similarityPercent(structure.autoFoundSimilarity)"
                                                    [showValue]="false"
                                                    styleClass="ei-similarity-bar">
                                            </p-progressBar>
                                        </div>
                                    }

                                    @if (structure.resolvedLookupScope != null) {
                                        <div class="mt-2">
                                            <p-tag
                                                    [value]="'Scope: ' + scopeLabel(structure.resolvedLookupScope)">
                                            </p-tag>
                                        </div>
                                    }
                                </div>
                                <div class="flex flex-column gap-2">
                                    <p-button
                                            label="Neu zuweisen"
                                            icon="fa-solid fa-arrow-right-arrow-left"
                                            severity="secondary"
                                            [text]="true"
                                            size="small"
                                            (onClick)="jumpToSearch(structure.id)">
                                    </p-button>
                                </div>
                            </div>
                        </div>
                    } @else {
                        <p-message
                                severity="warn"
                                text="Kein Objekt zugewiesen"
                                [closable]="false"
                                styleClass="block mb-3">
                        </p-message>
                    }

                    <!-- Scoped Lookup (candidates) -->
                    @if (record?.id && structure?.id) {
                        <div class="mt-2">
                            <h6 class="m-0 mb-2">Weitere Kandidaten</h6>
                            <mvs-ei-scoped-lookup
                                    [recordId]="record.id"
                                    [structureId]="structure.id"
                                    (onAssigned)="handleScopedAssigned(structure.id, $event)">
                            </mvs-ei-scoped-lookup>
                        </div>
                    }

                    <!-- Structure-level actions -->
                    <div class="flex justify-content-end gap-2 mt-3">
                        <p-button
                                label="Manuelle Zuweisung"
                                icon="fa-solid fa-magnifying-glass"
                                severity="info"
                                [text]="true"
                                size="small"
                                (onClick)="jumpToSearch(structure.id)">
                        </p-button>
                        <p-button
                                label="Erneut auflösen"
                                icon="fa-solid fa-rotate-right"
                                severity="info"
                                [text]="true"
                                size="small"
                                (onClick)="triggerReLookup()">
                        </p-button>
                    </div>

                </p-accordion-content>
            </p-accordion-panel>
        }
    </p-accordion>
}
